<template>
    <v-layout v-if="loading" align-center justify-center>
        <v-progress-circular indeterminate></v-progress-circular>
    </v-layout>
    <div v-else>
        <v-layout wrap>
            <v-flex xs12>
                <v-alert :value="error != null" outline type="error">
                    {{ error }}
                </v-alert>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-text-field v-model="search" append-icon="search" label="Filter" single-line hide-details></v-text-field>
            </v-flex>
            <v-flex xs12 sm3 offset-sm1>
                <v-checkbox class="active-checkbox" label="Active Only" v-model="activeOnly" hide-details></v-checkbox>
            </v-flex>
            <v-flex xs12 sm2 offset-sm1>
                <v-btn color="primary" block @click="showEditAddHMSKit({IsActive: true})">
                    Add
                </v-btn>
            </v-flex>
        </v-layout>
        <v-layout pt-3>
            <v-flex xs12>
                <v-data-table :rows-per-page-items="[10, 25, 50, { text: 'All', value: -1 }]" :headers="headers" :items="filteredItems" :search="search">
                    <template v-slot:items="{ item }">
                        <td>{{ item.Name }}</td>
                        <td>{{ item.Description }}</td>
                        <td>{{ item.PlantName }}</td>
                        <td>{{ item.SoftwareVersionName }}</td>
                        <td>{{ item.LastSynched | formatDate }}</td>
                        <td>{{ item.LastTeamName ? item.PlantName + "/" + item.LastTeamName : item.PlantName }}</td>
                        <td>{{ item.IndicatorName }}</td>
                        <td>{{ item.SecretKey }}</td>
                        <td>{{ item.Thumbprint }}</td>
                        <td>{{ item.Comments }}</td>
                        <td>{{ item.IsActive ? 'Active' : 'Inactive' }}</td>
                        <td>
                            <v-btn color="primary" block @click="showEditAddHMSKit(item)">
                                <span>Edit</span>
                            </v-btn>
                        </td>
                    </template>
                </v-data-table>
            </v-flex>
        </v-layout>
        <v-dialog :value="editing" fullscreen hide-overlay transition="dialog-bottom-transition">
            <HMSKitEdit v-if="editing" :item="editItem" :plantList="plantList" :indicatorList="indicatorList"
                :submitLoading="loading" :submitError="error" @submit="handleSubmit" @cancel="cancelEdit()">
            </HMSKitEdit>
        </v-dialog>
    </div>
</template>
    
<script>
import HMSKitEdit from "@/components/configuration/assets/HMSKitEdit.vue";
import AssetApi from '@/api/assetApi';
import PlantApi from '@/api/plantApi';

export default {
    components: {
        HMSKitEdit: HMSKitEdit
    },
    data() {
        return {
            editing: false,
            error: null,
            search: "",
            loading: false,
            activeOnly: true,
            editItem: null,
            hmsKits: [],
            plantList: [],
            softwareVersionList: [],
            indicatorList: [],
            headers: [
                {
                    text: "Asset Name",
                    value: "Name",
                    sortable: true
                },
                {
                    text: "Asset Description",
                    value: "Description",
                    sortable: true
                },
                {
                    text: "Plant",
                    value: "PlantName",
                    sortable: true
                },
                {
                    text: "Software Version",
                    value: "SoftwareVersionName",
                    sortable: true
                },
                {
                    text: "Last Synched",
                    value: "LastSynched",
                    sortable: true
                },
                {
                    text: "Last Plant-Team",
                    sortable: false
                },
                {
                    text: "Indicator",
                    value: "IndicatorName",
                    sortable: true
                },
                {
                    text: "Secret Key",
                    value: "SecretKey",
                    sortable: true
                },
                {
                    text: "Thumbprint",
                    value: "Thumbprint",
                    sortable: true
                },
                {
                    text: "Comments",
                    value: "Comments",
                    sortable: true
                },
                {
                    text: "Active",
                    value: "IsActive",
                    sortable: true
                },
                {
                    text: "Edit",
                    value: "DeviceID",
                    sortable: false
                }
            ]
        }
    },
    computed: {
        filteredItems() {
            if (!this.activeOnly) {
                return this.hmsKits;
            }
            return this.hmsKits.filter(c => c.IsActive);
        }
    },
    methods: {
        async loadHMSKits() {
            this.loading = true;
            this.error = null;

            try {
                this.hmsKits = await AssetApi.getHMSKits();
            } catch (err) {
                this.error = err;
            }

            this.loading = false;
        },
        showEditAddHMSKit(item) {
            this.editItem = item;
            this.editing = true;
        },
        cancelEdit() {
            this.editItem = null;
            this.error = null;
            this.editing = false;
        },
        async handleSubmit(item) {
            if (this.hmsKits.filter(a => a.Name === item.Name && a.DeviceID !== item.DeviceID).length > 0) {
                this.error = "HMS Kit with the same Asset Name already exists."
                return;
            }
            this.loading = true;

            try {
                let response = {};

                if (item.DeviceID > 0) {
                    response = await AssetApi.updateHMSKit(item);
                } else {
                    response = await AssetApi.addHMSKit(item);
                }

                if (!response.Success) {
                    this.error = response.ErrorMessages.join(', ');
                    return;
                }

                this.editing = false;
            } catch (err) {
                this.error = err;
                return;

            } finally {
                this.loading = false;
            }
            await this.loadHMSKits();
        }
    },
    async created() {
        await this.loadHMSKits();

        let plants = await PlantApi.getAllPlants();
        this.plantList = plants.map(x => {
            return {
                PlantID: x.PlantID,
                PlantName: x.PlantName
            };
        });

        this.indicatorList = await AssetApi.getAllIndicatorMinimals();
    }
}
</script>
    